import { Box, Grid } from '@mui/material';
import { capitalize, lowerCase } from 'lodash';
import EnteredDataSection from '@shared/components/EnteredDataSection';
import TermsAndConditionsCheckbox from '@shared/components/TermsAndConditionsCheckbox';
import moment from 'moment';
import ActionButton from '@shared/components/Buttons/ActionButton';

const EnteredData = ({ formik, copyPassenger, isLoading, searchData }) => {
  const isEmit = Boolean(searchData?.emit);

  // Datos de pasajeros para la tabla

  const passengerFieldsList = copyPassenger?.map(passenger => {
    const birthdate = passenger.birthdate
      ? moment(passenger.birthdate) // moment lo interpreta correctamente
      : null;

    const age = birthdate ? moment().diff(birthdate, 'years') : '';

    const documentType =
      passenger?.document_type?.toUpperCase() === 'DNI'
        ? 'DNI'
        : capitalize(lowerCase(passenger?.document_type));

    return {
      Nombre: passenger.name,
      Apellido: passenger.last_name,
      'Fecha de Nacimiento': birthdate ? birthdate.format('DD/MM/YYYY') : '',
      Edad: age,
      Documento: passenger?.document_number
        ? `${documentType}: ${passenger.document_number}`
        : '',
    };
  });

  return (
    <>
      <EnteredDataSection
        title="Datos Ingresados"
        fieldsList={passengerFieldsList}
      />
      {/* Checkbox de términos */}
      <Grid item xs={12} id="assist-acceptedTerms" sx={{ ml: '1vw' }}>
        <TermsAndConditionsCheckbox
          formik={formik}
          fieldName="acceptedTerms"
          dialogText="Términos y condiciones generales, condiciones de compra y políticas de cancelación."
        />
      </Grid>
      {/* Botón Confirmar */}
      <Grid item xs={12} md={12}>
        <Box
          sx={{
            width: '100%',
            mt: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <ActionButton
            isLoading={isLoading}
            onClick={formik.handleSubmit}
            buttonText={isEmit ? 'Emitir' : 'Continuar'}
            align="end"
          />
        </Box>
      </Grid>
    </>
  );
};

export default EnteredData;
